import React, { useState, useEffect } from 'react'
//import DEFAULT_URL from '../../../../../api/url';
import { Row, Alert, Button, Spinner, ListGroup, Col, Dropdown, Form, Container, Accordion, ButtonToolbar, ButtonGroup, DropdownButton, InputGroup } from "react-bootstrap";
import DetalleEnlace from './DetalleEnlace';
const DetalleSesion = (props) => {
    const [contador, setContador] = useState(0);
    const [enlaces, setEnlaces] = useState([]);
    const [exito, setExito] = useState('none');
    const [error, setError] = useState('none');
    const [cargando, setCargando] = useState('none');
    const [confirmacion, setConfirmacion] = useState('none');
    const [mensaje, setMensaje] = useState('');
    const [formulario, setFormulario] = useState('none');
    const [detalle, setDetalle] = useState('block');
    const [addEnlace, setAddEnlace] = useState('none');
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [url, setUrl] = useState('');
    const [tipo, setTipo] = useState('');
    const [comentario, setComentario] = useState('');
    const [tiposEnlace, setTiposEnlace] = useState([]);
    useEffect(() => {
        fetch(process.env.REACT_APP_DEFAULT_URL + '/api/read/enlace/' + props.sesion.UniqueID, { cache: "no-cache" })
            .then((res) => {
                return res.json();
            })
            .then(data => {
                setEnlaces(data.rows);
            });
        fetch(process.env.REACT_APP_DEFAULT_URL + '/api/read/tipos/enlace', { cache: "no-cache" })
            .then((res) => {
                return res.json();
            })
            .then(data => {
                setTiposEnlace(data.rows);
            });
    }, [contador]);
    const deleteSelf = () => {
        cargar('Sincronizando base de datos');
        const info = { UniqueID: props.sesion.UniqueID };
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(info)
        };
        fetch(process.env.REACT_APP_DEFAULT_URL + '/api/sesion/delete', requestOptions)
            .then((res) => {
                return res.json();
            })
            .then(data => {
                if (data.codigo === 200) {
                    operacionExito('Sesion eliminada exitosamente');
                } else {
                    operacionError('Error al eliminar registro en db');
                }
            });
    }
    const cargar = (mensaje) => {
        setExito('none');
        setDetalle('none');
        setError('none');
        setFormulario('none');
        setAddEnlace('none');
        setCargando('block');
        setConfirmacion('none');
        setMensaje(mensaje);
        setContador(contador + 1);
    }
    const confirmar = () => {
        setExito('none');
        setDetalle('none');
        setError('none');
        setCargando('none');
        setConfirmacion('block');
        setFormulario('none');
        setAddEnlace('none');
        setContador(contador + 1);
    }
    const operacionExito = (mensaje) => {
        setExito('block');
        setDetalle('none');
        setFormulario('none');
        setAddEnlace('none');
        setError('none');
        setCargando('none');
        setMensaje(mensaje);
        setContador(contador + 1);
    }
    const operacionError = (mensaje) => {
        setDetalle('none');
        setFormulario('none');
        setAddEnlace('none');
        setExito('none');
        setError('block');
        setCargando('none');
        setMensaje(mensaje);
        setContador(contador + 1);
    }

    const goBack = () => {
        setDetalle('block');
        setExito('none');
        setError('none');
        setCargando('none');
        setConfirmacion('none');
        setFormulario('none');
        setAddEnlace('none');
        setMensaje('');
        setUrl('');
        setTipo('');
        setFechaFin('');
        setFechaInicio('');
        setComentario('');
        props.refresh();
        setContador(contador + 1);
    }
    const goToAddEnlace = () => {
        setDetalle('none');
        setExito('none');
        setError('none');
        setCargando('none');
        setConfirmacion('none');
        setFormulario('none');
        setAddEnlace('block');
        setMensaje('');
        setContador(contador + 1);
    }
    const goToEdit = () => {
        setDetalle('none');
        setExito('none');
        setError('none');
        setCargando('none');
        setConfirmacion('none');
        setFormulario('block');
        setAddEnlace('none');
        setMensaje('');
        setFechaFin(props.sesion.fecha_fin);
        setFechaInicio(props.sesion.fecha_inicio);
        setContador(contador + 1);
    }
    const onChange = (evt) => {
        if (evt.target.name == 'url') {
            setUrl(evt.target.value);
        } else if (evt.target.name == 'tipo_enlace') {
            setTipo(evt.target.value);
        }
        else if (evt.target.name == 'comentario') {
            setComentario(evt.target.value);
        }
        else if (evt.target.name == 'fecha_inicio') {
            setFechaInicio(evt.target.value);
        } else {
            setFechaFin(evt.target.value);
        }
        setContador(contador + 1);
    }
    const submitEnlace = (evt) => {
        evt.preventDefault();
        cargar('Sincronizando base de datos');
        const info = { url: url, tipo: tipo, sesion: props.sesion.UniqueID, comentario: comentario };
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(info)
        };
        fetch(process.env.REACT_APP_DEFAULT_URL + '/api/create/enlace/', requestOptions)
            .then((res) => {
                return res.json();
            })
            .then(data => {
                if (data.codigo === 200) {
                    operacionExito('Enlace registrado exitosamente');
                } else {
                    operacionError('Error al almacenar registro en db');
                }
            });
    }
    const submitEditSesion = (evt) => {
        evt.preventDefault();
        cargar('Sincronizando base de datos');
        const info = { fecha_inicio: fechaInicio, fecha_fin: fechaFin, UniqueID: props.sesion.UniqueID };
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(info)
        };
        fetch(process.env.REACT_APP_DEFAULT_URL + '/api/sesion/update', requestOptions)
            .then((res) => {
                return res.json();
            })
            .then(data => {
                if (data.codigo === 200) {
                    operacionExito('Enlace registrado exitosamente');
                } else {
                    operacionError('Error al almacenar registro en db');
                }
            });
    }
    const sendRecordatorio = () => {
        cargar('Enviando información');
        fetch(process.env.REACT_APP_DEFAULT_URL + '/api/sesion/send-recordatorio/' + props.sesion.UniqueID)
            .then((res) => {
                return res.json();
            })
            .then(data => {
                if (data.codigo === 200) {
                    operacionExito('Correos enviados exitosamente');
                } else {
                    operacionError('Error al enviar correos');
                }
            });
    }
    return (
        <Row style={{ marginBottom: '25px' }}>
            <Container fluid>
                <Row style={{ display: detalle }}>
                    <Container fluid>
                        <Row style={{ marginBottom: '25px' }}>
                            <h2>Sesion #{props.indice + 1}</h2>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={4} style={{ marginTop: '25px' }}>
                                <h3><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-hourglass-split" viewBox="0 0 16 16">
                                    <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
                                </svg>&nbsp;&nbsp;&nbsp;&nbsp;Horario</h3>
                                <p><strong>Inicio: </strong>{props.sesion.fechaInicio}</p>
                                <p><strong>Fin: </strong>{props.sesion.fechaFin}</p>
                                <Dropdown>
                                    <Dropdown.Toggle variant="outline-success" id="dropdown-basic">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-gear-wide-connected" viewBox="0 0 16 16">
                                            <path d="M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434l.071-.286zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5zm0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78h4.723zM5.048 3.967c-.03.021-.058.043-.087.065l.087-.065zm-.431.355A4.984 4.984 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8 4.617 4.322zm.344 7.646.087.065-.087-.065z" />
                                        </svg>&nbsp;&nbsp;&nbsp;Acciones
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={sendRecordatorio}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send-check-fill" viewBox="0 0 16 16">
                                            <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                            <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                        </svg>&nbsp;&nbsp;&nbsp;Enviar recordatorio a participantes</Dropdown.Item>
                                        <Dropdown.Item onClick={goToAddEnlace}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-circle-dotted" viewBox="0 0 16 16">
                                            <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                        </svg>&nbsp;&nbsp;&nbsp;Añadir enlace</Dropdown.Item>
                                        <Dropdown.Item onClick={goToEdit}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-fill" viewBox="0 0 16 16">
                                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                        </svg>&nbsp;&nbsp;&nbsp;Editar sesión</Dropdown.Item>
                                        <Dropdown.Item style={{ color: 'red' }} onClick={confirmar}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                                        </svg>&nbsp;&nbsp;&nbsp;Eliminar sesión</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                            <Col xs={12} md={12} lg={8} style={{ marginTop: '25px' }}>
                                <h3><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                                    <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                                </svg>&nbsp;&nbsp;&nbsp;&nbsp;Enlaces</h3>
                                <Container fluid>
                                    {enlaces.map((actual, index) => <DetalleEnlace enlace={actual} refresh={() => { setContador(contador + 1); }} enlaces={enlaces.length} />)}
                                </Container>
                            </Col>
                        </Row>
                    </Container>
                </Row>
                <Row style={{ display: addEnlace }}>
                    <Container fluid>
                        <Form onSubmit={submitEnlace}>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="url">
                                        <Form.Label>Url</Form.Label>
                                        <Form.Control required type="text" name="url" value={url} placeholder="Url de enlace" onChange={onChange} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="tipo_enlace">
                                        <Form.Label>Tipo de enlace</Form.Label>
                                        <Form.Control as="select" required aria-label="Tipo Enlace" value={tipo} name="tipo_enlace" onChange={onChange}>
                                            <option value="" key="0">Seleccione el tipo de enlace</option>
                                            {tiposEnlace.map(tipo => <option key={tipo.UniqueID} value={tipo.UniqueID}>{tipo.Nombre}</option>)}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Form.Group className="mb-3" controlId="comentario">
                                    <Form.Label>Comentario o instrucciones de enlace</Form.Label>
                                    <Form.Control as="textarea" rows={3} style={{ resize: 'none' }} name="comentario" onChange={onChange} value={comentario} />
                                </Form.Group>
                            </Row>
                            <Row>
                                <Button type="submit" variant='outline-success'>
                                    Guardar enlace
                                </Button>
                            </Row>
                            <Row style={{ marginTop: '25px' }}>
                                <Button variant='outline-dark' onClick={goBack}>
                                    Cancelar
                                </Button>
                            </Row>
                        </Form>
                    </Container>
                </Row>
                <Row style={{ display: formulario }}>
                    <Form onSubmit={submitEditSesion}>
                        <Container>
                            <Row style={{ padding: '15px' }}>
                                <h1>Editar sesión</h1>
                            </Row>
                            <Row style={{ padding: '15px' }}>
                                <Col xs={12} md={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="url">
                                        <Form.Label>Fecha y hora de inicio</Form.Label>
                                        <Form.Control required type="datetime-local" name="fecha_inicio" value={fechaInicio} placeholder="Fecha y hora de inicio" onChange={onChange} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="url">
                                        <Form.Label>Fecha y hora de finalización</Form.Label>
                                        <Form.Control required type="datetime-local" name="fecha_fin" value={fechaFin} placeholder="Fecha y hora de finalización" onChange={onChange} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Button type="submit" variant='outline-success'>
                                    Guardar cambios
                                </Button>
                            </Row>
                            <Row style={{ marginTop: '25px' }}>
                                <Button variant='outline-dark' onClick={goBack}>
                                    Cancelar
                                </Button>
                            </Row>
                        </Container>
                    </Form>
                </Row>
                <Row style={{ display: exito }}>
                    <Alert variant='success'>
                        <Alert.Heading>
                            Operación realizada con éxito
                        </Alert.Heading>
                        <p>
                            {mensaje}
                        </p>
                        <hr />
                        <div className="d-flex justify-content-end">
                            <Button variant='outline-success' onClick={() => { goBack(); props.refresh(); }}>
                                Ok
                            </Button>
                        </div>
                    </Alert>
                </Row>
                <Row style={{ display: error }}>
                    <Alert variant='danger'>
                        <Alert.Heading>
                            Ocurrió un error al ingresar la propuesta
                        </Alert.Heading>
                        <p>
                            {mensaje}
                        </p>
                        <hr />
                        <div className="d-flex justify-content-end">
                            <Button variant='outline-danger' onClick={goBack}>
                                Ok
                            </Button>
                        </div>
                    </Alert>
                </Row>
                <Row style={{ display: cargando }}>
                    <Alert variant='dark'>
                        <Alert.Heading>
                            <Spinner animation="border" role="status">
                            </Spinner>&nbsp;&nbsp;&nbsp;
                            Ingresando información
                        </Alert.Heading>
                        <p>
                            {mensaje}
                        </p>
                        <hr />
                        <p>
                            Por favor espere...
                        </p>
                    </Alert>
                </Row>
                <Row style={{ display: confirmacion }}>
                    <Alert variant='warning'>
                        <Alert.Heading>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                            </svg>&nbsp;&nbsp;&nbsp;Se necesita confirmación
                        </Alert.Heading>
                        <p>
                            ¿Está segur@ de eliminar la sesión seleccionada?
                            <br />
                            <strong>Fecha inicio </strong> {props.sesion.fechaInicio}
                            <br />
                            <strong>Fecha fin: </strong> {props.sesion.fechaFin}
                            <br />
                            <strong>#enlaces: </strong> {enlaces.length}

                        </p>
                        <hr />
                        <div className="d-flex justify-content-end">
                            <Button variant='outline-danger' onClick={deleteSelf}>
                                si
                            </Button>&nbsp;&nbsp;&nbsp;
                            <Button variant='outline-dark' onClick={goBack}>
                                no
                            </Button>
                        </div>
                    </Alert>
                </Row>
            </Container>
        </Row>
    )
}

export default DetalleSesion